module.exports = __webpack_public_path__ + "img/background-chat.a2e62ace.jpg";